import React, { useEffect, useRef } from "react";
import Datetime from "react-datetime";
import PropTypes from "prop-types";
import { Redirect, useParams } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import MailOutline from "@material-ui/icons/MailOutline";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";

import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import { bookingApi } from "functions/apis";

const useStyles = makeStyles(styles);

export default function Edit(props) {
  const source = useRef(new AbortController());
  const { id } = useParams();

  useEffect(() => {
    return () => source.current.abort();
  }, []);

  const [state, setState] = React.useState({
    effectiveDate: null,
    lookUpCode: "",
    IDR: 0,
    SGD: 0
  });
  const [redirect, setRedirect] = React.useState(false);
  const [disabled, setDisabled] = React.useState(false);

  useEffect(() => {
    bookingApi
      .get("/PDFs/" + id, {
        signal: source.current.signal
      })
      .then(data => {
        setState({
          effectiveDate: data.effectiveDate
            ? new Date(data.effectiveDate + "Z")
            : null,
          lookUpCode: data.lookUpCode || "",
          IDR: data.idr || 0,
          SGD: data.sgd || 0
        });
      })
      .catch(error => console.log(error));
  }, [id]);

  const handleFeeChanged = field => e => {
    const value = e && e.target ? e.target.value : "";

    setState(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    setDisabled(true);
    bookingApi
      .put(
        "/PDFs/" + id,
        {
          ...state,
          IDR: parseFloat(state.IDR),
          SGD: parseFloat(state.SGD)
        },
        {
          signal: source.current.signal
        }
      )
      .then(() => setRedirect(true))
      .catch(error => {
        console.log(error);
        setDisabled(false);
      });
  };

  const classes = useStyles();

  return redirect ? (
    <Redirect to="/admin/PDFs/List" />
  ) : (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>EDIT PDF</h4>
          </CardHeader>
          <CardBody>
            <Button onClick={() => props.history.goBack()} value="Back">
              BACK
            </Button>
            <form onSubmit={handleSubmit}>
              <FormControl fullWidth>
                <Datetime
                  value={state.effectiveDate}
                  onChange={value =>
                    setState(prev => ({
                      ...prev,
                      effectiveDate: value === "" ? null : value
                    }))
                  }
                  timeFormat={true}
                  closeOnSelect={true}
                  inputProps={{
                    placeholder: "Effective Date"
                  }}
                />
              </FormControl>
              <GridContainer>
                <GridItem xs={12} sm={12}>
                  <CustomInput
                    labelText="Look Up Code"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{
                      onChange: handleFeeChanged("lookUpCode"),
                      value: state.lookUpCode
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="IDR"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{
                      type: "number",
                      onChange: handleFeeChanged("IDR"),
                      value: state.IDR
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="SGD"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{
                      type: "number",
                      onChange: handleFeeChanged("SGD"),
                      value: state.SGD
                    }}
                  />
                </GridItem>
              </GridContainer>
              <Button disabled={disabled} color="rose" type="submit">
                Submit
              </Button>
            </form>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}

Edit.propTypes = {
  history: PropTypes.object
};
